import React from "react";

import { TableRowProps } from "./TableRow.types";

const TableRow: React.FC<TableRowProps> = ({ children, className }) => (
    <tr className={className}>{children}</tr>
);
export default TableRow;
